import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions,connectFunctionsEmulator } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyAI0J4KWj4rWGhXZqbx-X9_s_0oBdMw8rY",
  authDomain: "exqura-489cf.firebaseapp.com",
  projectId: "exqura-489cf",
  storageBucket: "exqura-489cf.firebasestorage.app",
  messagingSenderId: "20810200873",
  appId: "1:20810200873:web:047453c5ef7370a67da938"
};

const app = initializeApp(firebaseConfig);

export const functions = getFunctions(app, "us-central1");

// if (window.location.hostname === "localhost") {
//   // 5001 is the default port for Firebase Functions emulator
//   connectFunctionsEmulator(functions, "127.0.0.1", 5001);
//   console.log("Connected to local Functions Emulator");
// }

export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
